export const AUTH_ERROR_CODES = Object.freeze({
  NotAuthorizedException: 'NotAuthorizedException',
  UserNotConfirmedException: 'UserNotConfirmedException',
  UserNotFoundException: 'UserNotFoundException',
  LimitExceededException: 'LimitExceededException',
  ExpiredCodeException: 'ExpiredCodeException',
  CodeMismatchException: 'CodeMismatchException',
});
